function initJom(root = document) {
  const menuToggle = document.querySelector('.jom-menu-toggle');
  const mainNav = document.querySelector('#jom-main-nav');
  const closeMenu = () => { mainNav?.classList.remove('is-open'); menuToggle?.setAttribute('aria-expanded', 'false'); document.body.classList.remove('jom-menu-open'); };
  if (menuToggle && !menuToggle.dataset.jomWired) {
  menuToggle.dataset.jomWired = 'true';
  menuToggle.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') !== 'true';
    mainNav?.classList.toggle('is-open', open);
    menuToggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('jom-menu-open', open);
  });
  document.querySelector('.jom-menu-close')?.addEventListener('click', closeMenu);

  mainNav?.querySelectorAll('.jom-nav-group').forEach(group => group.addEventListener('toggle', () => {
    if (group.open) mainNav.querySelectorAll('.jom-nav-group').forEach(other => { if (other !== group) other.open = false; });
  }));

  }
  const collectionFilters = document.querySelectorAll('[data-collection-filter]');
  collectionFilters.forEach(filter => { if (filter.dataset.jomWired) return; filter.dataset.jomWired = 'true'; filter.addEventListener('click', () => {
    collectionFilters.forEach(button => button.classList.toggle('is-active', button === filter));
    const value = filter.dataset.collectionFilter;
    filter.closest('.jom-collection-products')?.querySelectorAll('.jom-collection-guide').forEach(guide => { guide.hidden = value !== 'all'; });
    let visible = 0;
    filter.closest('.jom-collection-products')?.querySelectorAll('[data-collection-product]').forEach(card => {
      const title = card.dataset.title || '';
      const type = card.dataset.type || '';
      const match = value === 'all' || (value === 'sets' ? /set|bundel/.test(title + type) : value === 'smaken' ? /lemon|ginger|golden|chai|skinny|detox|smaak/.test(title + type) : (title + type).includes(value));
      card.hidden = !match;
      if (match) visible += 1;
    });
    const count = filter.closest('.jom-collection-products')?.querySelector('.jom-collection-sort span');
    if (count) count.textContent = `${visible} ${visible === 1 ? 'product' : 'producten'}`;
  }); });

  const drawer = () => document.querySelector('#jom-cart-drawer');
  const syncDigitalGifts = async cart => {
    const updates = {};
    for (const item of cart.items) {
      const parent = item.properties?._jom_gift_for;
      if (!parent || item.requires_shipping || item.price !== 0) continue;
      const quantity = cart.items.filter(line => String(line.product_id) === parent && !line.properties?._jom_gift_for).reduce((total, line) => total + line.quantity, 0);
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    if (!Object.keys(updates).length) return cart;
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/update.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
    if (!response.ok) throw new Error('Cart update failed');
    return response.json();
  };
  const refreshDrawer = async (open = false) => {
    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
    if (!cartResponse.ok) throw new Error('Cart unavailable');
    const cart = await syncDigitalGifts(await cartResponse.json());
    const response = await fetch(`${root}?section_id=cart-drawer`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart unavailable');
    const html = await response.text();
    const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('#jom-cart-drawer');
    if (!replacement || !drawer()) throw new Error('Cart section unavailable');
    drawer().replaceWith(replacement);
    if (open) replacement.showModal();
    const cartLink = document.querySelector('.jom-cart-link');
    if (cartLink) {
      cartLink.querySelector('span:last-child').textContent = cart.item_count;
      cartLink.setAttribute('aria-label', `Winkelwagen, ${cart.item_count} ${cart.item_count === 1 ? 'artikel' : 'artikelen'}`);
    }
  };
  if (document.querySelector('[data-cart-page] [data-cart-digital-gift]') && !document.documentElement.dataset.jomGiftsWired) {
    document.documentElement.dataset.jomGiftsWired = 'true';
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart.js`, { credentials: 'same-origin' }).then(response => response.json()).then(async cart => {
      const updated = await syncDigitalGifts(cart);
      if (JSON.stringify(updated.items) !== JSON.stringify(cart.items)) window.location.reload();
    }).catch(() => {});
  }
  const cartTrigger = document.querySelector('.jom-cart-link');
  if (cartTrigger && !cartTrigger.dataset.jomWired) {
  cartTrigger.dataset.jomWired = 'true';
  cartTrigger.addEventListener('click', event => {
    if (!drawer()) return;
    event.preventDefault();
    const cartHref = event.currentTarget.href;
    refreshDrawer(true).catch(() => { window.location.href = cartHref; });
  });
  }
  if (!document.documentElement.dataset.jomCartWired) {
  document.documentElement.dataset.jomCartWired = 'true';
  document.addEventListener('click', async event => {
    if (event.target.closest('.jom-drawer-close')) drawer()?.close();
    const change = event.target.closest('[data-cart-change]');
    if (!change) return;
    change.disabled = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const quantity = Math.max(0, Number(change.parentElement.querySelector('span').textContent) + Number(change.dataset.cartChange));
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(change.dataset.line), quantity }) });
      if (!response.ok) throw new Error('Cart update failed');
      await refreshDrawer(true);
    } catch { window.location.href = document.querySelector('.jom-cart-link')?.href || '/cart'; }
  });
  document.addEventListener('submit', async event => {
    const quickForm = event.target.closest('.jom-card-quick-form');
    if (!quickForm) return;
    event.preventDefault();
    const button = quickForm.querySelector('button[type="submit"]');
    const variantId = Number(quickForm.querySelector('[name="id"]')?.value);
    if (!button || !variantId || button.disabled) return;
    button.disabled = true;
    button.textContent = 'toevoegen…';
    try {
      const addUrl = new URL(quickForm.action);
      addUrl.pathname += '.js';
      const response = await fetch(addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
      if (!response.ok) throw new Error('Product kon niet worden toegevoegd');
      button.textContent = 'toegevoegd ✓';
      if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
      await refreshDrawer(true).catch(() => { window.location.href = document.querySelector('.jom-cart-link')?.href || '/cart'; });
    } catch { button.textContent = 'probeer opnieuw'; }
    finally { button.disabled = false; }
  });
  }
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery && !gallery.dataset.jomWired) {
    gallery.dataset.jomWired = 'true';
    const allSlides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const allThumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    let slides = allSlides.filter(slide => slide.dataset.galleryProduct === gallery.dataset.galleryCurrentProduct);
    let thumbs = allThumbs.filter(thumb => thumb.dataset.galleryProduct === gallery.dataset.galleryCurrentProduct);
    let current = 0;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; slide.classList.toggle('is-active', i === current); });
      thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === current); thumb.setAttribute('aria-pressed', String(i === current)); });
      const track = gallery.querySelector('.jom-pdp-thumbnails');
      const active = thumbs[current];
      if (track && active) track.scrollTo({ left: active.offsetLeft - track.offsetLeft - (track.clientWidth - active.clientWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    allThumbs.forEach(thumb => thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb))));
    gallery.jomSelectProduct = productId => {
      if (!productId || productId === gallery.dataset.galleryCurrentProduct) return;
      const productSlides = allSlides.filter(slide => slide.dataset.galleryProduct === productId);
      if (!productSlides.length) return;
      gallery.dataset.galleryCurrentProduct = productId;
      allSlides.forEach(slide => { slide.hidden = true; slide.classList.remove('is-active'); });
      allThumbs.forEach(thumb => { thumb.hidden = thumb.dataset.galleryProduct !== productId; thumb.classList.remove('is-active'); thumb.setAttribute('aria-pressed', 'false'); });
      slides = productSlides;
      thumbs = allThumbs.filter(thumb => thumb.dataset.galleryProduct === productId);
      const carousel = gallery.querySelector('.jom-pdp-carousel');
      if (carousel) carousel.hidden = slides.length < 2;
      const badge = gallery.querySelector('.jom-pdp-image-badge');
      if (badge) badge.hidden = productId !== allSlides[0]?.dataset.galleryProduct;
      show(0);
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    const mainImage = gallery.querySelector('.jom-pdp-main-image');
    let swipe = null;
    mainImage?.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse' || !event.isPrimary || slides.length < 2) { swipe = null; return; }
      swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
      mainImage.setPointerCapture(event.pointerId);
    });
    mainImage?.addEventListener('pointerup', event => {
      if (!swipe || event.pointerId !== swipe.id) return;
      const dx = event.clientX - swipe.x;
      const dy = event.clientY - swipe.y;
      swipe = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25) show(current + (dx < 0 ? 1 : -1));
    });
    mainImage?.addEventListener('pointercancel', () => { swipe = null; });
  }

  const form = document.querySelector('#jom-product-form');
  const dataElement = document.querySelector('#jom-product-data');
  if (!form || !dataElement || form.dataset.jomWired) return;
  form.dataset.jomWired = 'true';
  const data = JSON.parse(dataElement.textContent);
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', { style: 'currency', currency: data.currency || 'EUR' });
  const formatPrice = cents => formatter.format(cents / 100).replace(/€[\s\u00a0\u202f]+/u, '€');
  const price = document.querySelector('#jom-price');
  const compare = document.querySelector('#jom-compare-price');
  const save = document.querySelector('#jom-save');
  const stickyPrice = document.querySelector('#jom-sticky-price');
  const stickyCups = document.querySelector('#jom-sticky-cups');
  const purchase = form.querySelector('[data-purchase-options]');
  const crossSells = form.querySelector('[data-ritual-cross-sells]');
  if (crossSells) crossSells.hidden = false;
  const sticky = document.querySelector('.jom-pdp-sticky-atc');
  const mainButton = form.querySelector('.jom-pdp-add');
  if (sticky && mainButton) {
    sticky.querySelector('button')?.addEventListener('click', event => { event.preventDefault(); event.stopImmediatePropagation(); form.requestSubmit(mainButton); }, true);
    let stickyFrame = 0;
    const updateSticky = () => {
      if (stickyFrame) return;
      stickyFrame = requestAnimationFrame(() => {
        sticky.hidden = mainButton.getBoundingClientRect().bottom >= 0;
        stickyFrame = 0;
      });
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    form.jomStickyCleanup = () => { window.removeEventListener('scroll', updateSticky); window.removeEventListener('resize', updateSticky); cancelAnimationFrame(stickyFrame); };
    updateSticky();
  }

  const option = () => form.querySelector('#jom-variant')?.selectedOptions[0] || form.querySelector('.jom-pdp-tier input:checked') || form.querySelector('input[name="id"]');
  const syncDeliveryDescription = () => {
    const select = form.querySelector('#appstle_subscription_widget0 .appstle_select');
    const description = form.querySelector('.appstleSelectedSellingPlanOptionDescription');
    const interval = select?.selectedOptions[0]?.textContent.trim();
    if (!description || !interval) return;
    const text = (data.deliveryEvery || '__interval__').replace('__interval__', interval);
    if (description.textContent !== text) description.textContent = text;
  };
  const update = () => {
    syncDeliveryDescription();
    const selected = option();
    if (!selected) return;
    gallery?.jomSelectProduct?.(selected.dataset.productId);
    if (form.dataset.ritualPending !== 'true') {
      const unavailable = Boolean(selected.disabled) || (data.giftRequired && !data.giftReady);
      if (mainButton) { mainButton.disabled = unavailable; const label = mainButton.querySelector('span'); if (label) label.textContent = unavailable ? data.soldOutLabel : data.addLabel; }
      const stickyButton = sticky?.querySelector('button');
      if (stickyButton) { stickyButton.disabled = unavailable; const label = stickyButton.querySelector('span'); if (label) label.textContent = unavailable ? data.soldOutLabel : data.addLabel; }
    }
    form.querySelectorAll('.jom-pdp-tier').forEach(tier => tier.classList.toggle('is-active', tier.contains(selected)));
    const selectedPlan = form.querySelector('[name="selling_plan"]:checked')?.value;
    const subscription = Boolean(selectedPlan);
    const basePrice = Number(selected.dataset.price || data.basePrice);
    const referencePrice = Math.max(basePrice, Number(selected.dataset.comparePrice || basePrice));
    const planPrice = Number(selected.dataset.planPrice || 0);
    const finalPrice = subscription && planPrice ? planPrice : basePrice;
    if (price) price.textContent = formatPrice(finalPrice);
    const addOnPrice = [...form.querySelectorAll('[data-ritual-addon][aria-pressed="true"]')].reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
    if (stickyPrice) stickyPrice.textContent = formatPrice(finalPrice + addOnPrice);
    if (stickyCups) stickyCups.textContent = selected.dataset.label || (selected.dataset.cups ? `${selected.dataset.cups} kopjes` : selected.textContent.split('—')[0].trim());
    if (compare) {
      compare.hidden = referencePrice <= finalPrice;
      compare.textContent = formatPrice(referencePrice);
    }
    if (save) {
      const savings = referencePrice - finalPrice;
      save.hidden = savings <= 0;
      if (savings > 0) save.textContent = `je bespaart ${formatPrice(savings)}`;
    }
    form.querySelectorAll('.jom-pdp-tier').forEach(tier => {
      const input = tier.querySelector('input');
      const tierPrice = Number(subscription && input?.dataset.planPrice ? input.dataset.planPrice : input?.dataset.price);
      const amount = tier.querySelector('.jom-pdp-tier-price');
      const shipping = tier.querySelector('.jom-pdp-tier-shipping');
      const discount = tier.querySelector('[data-tier-discount]');
      const tierReference = Math.max(Number(input?.dataset.price || 0), Number(input?.dataset.comparePrice || 0));
      if (discount) {
        const percentage = tierReference > tierPrice ? Math.round((tierReference - tierPrice) * 100 / tierReference) : 0;
        discount.hidden = percentage <= 0;
        discount.textContent = `-${percentage}%`;
      }
      if (amount && Number.isFinite(tierPrice)) amount.textContent = formatPrice(tierPrice);
      const perCup = tier.querySelector('[data-price-per-cup]');
      const cups = Number(perCup?.dataset.cups);
      if (perCup && cups > 0 && Number.isFinite(tierPrice)) {
        perCup.textContent = perCup.dataset.template.replace('__amount__', formatPrice(Math.round(tierPrice / cups)));
      }
      if (shipping) shipping.hidden = !(data.shippingThreshold > 0 && tierPrice >= data.shippingThreshold);
    });
  };
  // Capture prevents an app handler from adding the main line a second time.
  form.addEventListener('submit', async event => {
    const addOns = [...form.querySelectorAll('[data-ritual-addon][aria-pressed="true"]')];
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.ritualPending === 'true' || !form.reportValidity()) return;
    if (data.giftRequired && !data.giftReady) return;
    const payload = new FormData(form);
    const main = { id: Number(payload.get('id')), quantity: Number(payload.get('quantity') || 1) };
    const plan = form.querySelector('[name="selling_plan"]:checked')?.value || payload.get('selling_plan');
    if (plan) main.selling_plan = Number(plan);
    const properties = Object.fromEntries([...payload].filter(([key]) => key.startsWith('properties[')).map(([key, value]) => [key.slice(11, -1), value]));
    if (Object.keys(properties).length) main.properties = properties;
    const items = [main, ...addOns.map(input => ({ id: Number(input.dataset.variantId), quantity: 1 }))];
    const gift = form.querySelector('[data-digital-gift]');
    if (gift && Number(gift.dataset.variantId) !== main.id) items.push({ id: Number(gift.dataset.variantId), quantity: main.quantity, properties: { _jom_gift_for: gift.dataset.productId } });
    const error = form.querySelector('[data-ritual-error]');
    const buttons = [...document.querySelectorAll('#jom-product-form button[type="submit"], button[form="jom-product-form"]')];
    const originalDisabled = buttons.map(button => button.disabled);
    form.dataset.ritualPending = 'true';
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => { button.disabled = true; });
    if (error) error.hidden = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || data.addError);
      // The cart write succeeded: a drawer failure must not retry the addition.
      await refreshDrawer(true).catch(() => { window.location.href = data.cartUrl; });
    } catch (failure) {
      if (error) { error.textContent = failure.message || data.addError; error.hidden = false; error.focus(); }
    } finally {
      form.dataset.ritualPending = 'false';
      form.removeAttribute('aria-busy');
      buttons.forEach((button, index) => { button.disabled = originalDisabled[index]; });
    }
  }, true);
  form.addEventListener('click', event => {
    const button = event.target.closest('[data-ritual-addon]');
    if (!button || button.disabled || form.dataset.ritualPending === 'true') return;
    const added = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(added));
    button.textContent = added ? button.dataset.addedLabel : button.dataset.addLabel;
    button.closest('.jom-pdp-addon')?.classList.toggle('is-active', added);
    update();
  });
  form.addEventListener('change', update);
  update();

  if (purchase) {
    // A URL-selected plan already consumes the default; later URL updates must not reset the user's choice.
    let defaultApplied = new URLSearchParams(location.search).has('selling_plan');
    form.addEventListener('change', event => {
      if (event.target.name === 'selling_plan') defaultApplied = true;
    });
    const wireWidget = () => {
      const widget = form.querySelector('#appstle_subscription_widget0');
      if (!widget) return;
      const moved = widget.parentElement !== purchase;
      if (moved) purchase.append(widget);
      const subscriptionDescription = widget.querySelector('.appstle_subscription_description_text');
      if (subscriptionDescription && !subscriptionDescription.querySelector('.jom-subscription-note')) {
        const note = document.createElement('p');
        note.className = 'jom-subscription-note';
        note.textContent = 'pauzeer, wijzig of stop wanneer je wilt.';
        subscriptionDescription.append(note);
      }
      if (!defaultApplied && data.subscriptionDefault && !new URLSearchParams(location.search).has('selling_plan')) {
        defaultApplied = true;
        const subscriptionRadio = [...widget.querySelectorAll('input[name="selling_plan"]')].find(input => input.value);
        subscriptionRadio?.click();
      }
      syncDeliveryDescription();
      if (moved) update();
    };
    const observer = new MutationObserver(wireWidget);
    form.jomObserver = observer;
    observer.observe(form, { subtree: true, childList: true });
    wireWidget();
  }

  const badge = document.querySelector('.jom-pdp-rating .jdgm-prev-badge');
  const count = Number(badge?.dataset.numberOfReviews);
  const rating = Number(badge?.dataset.averageRating);
  const reviewCount = document.querySelector('#jom-review-count');
  const reviewRating = document.querySelector('#jom-review-rating');
  const badgeRating = document.querySelector('#jom-badge-rating');
  if (count > 0 && reviewCount) reviewCount.textContent = count.toLocaleString(document.documentElement.lang || 'nl-BE');
  if (rating > 0 && reviewRating) reviewRating.textContent = rating.toLocaleString(document.documentElement.lang || 'nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (count > 0 && rating > 0 && badgeRating) badgeRating.textContent = `${rating.toLocaleString(document.documentElement.lang || 'nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} · ${count.toLocaleString(document.documentElement.lang || 'nl-BE')} beoordelingen`;
}
document.addEventListener('DOMContentLoaded', () => initJom());
document.addEventListener('shopify:section:load', event => initJom(event.target));
document.addEventListener('shopify:section:unload', event => { const form = event.target.querySelector('#jom-product-form'); form?.jomObserver?.disconnect(); form?.jomStickyCleanup?.(); });

document.addEventListener('keydown', event => { if (event.key !== 'Escape') return; document.querySelector('.jom-nav')?.classList.remove('is-open'); document.querySelector('.jom-menu-toggle')?.setAttribute('aria-expanded','false'); document.body.classList.remove('jom-menu-open'); });

document.addEventListener('click', event => {
  const button = event.target.closest('[data-promise-pause]');
  if (!button) return;
  const paused = button.getAttribute('aria-pressed') !== 'true';
  button.setAttribute('aria-pressed', String(paused));
  button.closest('[data-promise-strip]').dataset.paused = String(paused);
  button.setAttribute('aria-label', paused ? 'Scrollen hervatten' : 'Scrollen pauzeren');
  button.textContent = paused ? '▶' : 'Ⅱ';
});
